/**
 * ESM shim over the VENDORED currency module.
 *
 * Everything under `./vendored/` (registry, parse, normalize, format, index
 * and `vectors.json`) is copied BYTE-IDENTICAL from keepr-api
 * (`utils/currency/`) and must never be edited here -- `vectors.json` is the
 * lock-step guarantee, driven by `__tests__/currency.vectors.test.js`, which
 * also byte-compares every vendored file against keepr-api's main. The
 * vendored files are CommonJS because the API runs them under Node; this
 * shim is the only thing standing between them and the app's ESM imports, so
 * app code should always `import { formatCurrency } from '../utils/currency'`
 * and never reach into `vendored/` directly.
 */
import currency from './vendored/index';

export const {
	// Registry.
	CURRENCIES,
	CURRENCY_LIST,
	MAX_AMOUNT,
	getCurrency,
	isCurrencyCode,
	exponentOf,
	allowedCodes,
	defaultCodeOf,
	resolveCurrency,
	isCurrencyValue,

	// Parsing.
	decimalTextOf,
	toMinor,
	parseCurrency,
	parseCurrencyDetailed,

	// Normalisation.
	normalizeCurrency,
	readCurrency,

	// Formatting.
	STYLES,
	majorText,
	toMajor,
	symbolFor,
	formatAmount,
	formatCurrency,
	formatMajor,
} = currency;

export default currency;
